import React from 'react';

var VerifyEmailPopup = React.createClass({
	getInitialState: function(){
		return {value: "", errMsg: "", errclas: "", animation: null}
	},
	handleChange: function(e){
		this.setState({value: e.target.value, errMsg: "", errclas: ""});
	},
	handleResendClick: function(){
		// re for email
		var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(re.test(this.state.value)){
			this.props.verifyEmail("submit", this.state.value.toLowerCase());
			// this.setState({"animation": <span className = "fa fa-spinner fa-pulse fa-1x fa-fw"/>});
		} else {
			this.setState({errMsg: "Please enter a valid email.", errclas: "field__error--input"});
		}
	},
	handleCloseClick: function(){
		this.props.verifyEmail("close");
	},
	handleContinueClick: function(){
		this.props.verifyEmail("continue");
	},
	handleStopPropogation: function(e) {
		e.stopPropagation();
	},
	render: function() {
		return (
			<div className="modal__mask" onClick = {this.handleCloseClick}>
				<div className="modal__content modal--md" onClick = {this.handleStopPropogation}>
				  <div className="modal__header">
				    <h3 className="modal__header--title">Verify Your Email</h3>
				    <a href="javascript:void(0)" className="modal__close" onClick = {this.handleCloseClick}><i className="fa  fa-close"> </i></a> </div>
				  <div className="modal__body clearfix">
				    <div className="form__row clearfix">
				      <p>We sent you an email with a verification link. Please look for it in your inbox. If you haven’t received it, click resend and we'll send it again. Thank you.</p>
				    </div>
				    <div className="form__row clearfix">      
				      <div className="form__cell">
				       {this.state.errMsg ?
				       <p className ="field__error--text">{this.state.errMsg}</p> : null }
				        <div className="validate_form">
				        	<div className={this.state.errclas}>
				        		<input type="text" onChange = {this.handleChange} value={this.state.value}/>
				        	</div>
				            <div className="resend__btn"> 
				            	<button className="btn__lg bg-dark validate__btn"  onClick = {this.handleResendClick}><span>Resend</span> {this.state.animation}</button>
				            </div>
				        </div>
				      </div>
				    </div>
				    <div className="buttons clearfix">      
				      <button className="btn__lg bg-very_light" onClick = {this.handleCloseClick}>Cancel</button>
				      <button className="btn__lg bg-dark" onClick = {this.handleContinueClick}>Continue</button>
				    </div>
				  </div>  
				</div>
			</div>
		);
	}
});

export {VerifyEmailPopup};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/VerifyEmailPopup.jsx
 **/